import React, {useState} from 'react';
import Modal from 'shared/components/modal';
import Image2 from 'shared/img/college-search-welcome-modal-image-2.svg';
import Image1 from 'shared/img/college-search-welcome-modal-image-1.svg';

interface Props {
  handleClose: () => void;
}

type SvgComponent = React.FC<React.SVGProps<SVGSVGElement>>;

interface ModalContent {
  title: string;
  text: React.ReactNode;
  ModalImage: SvgComponent;
}

const WelcomeModal = ({handleClose}: Props) => {
  const [step, setStep] = useState(0);

  const onNextClick = () => {
    if (step === 1) {
      handleClose();
    } else {
      setStep(step + 1);
    }
  };

  const onBackClick = () => {
    setStep(step - 1);
  };

  const getModalContent = () => {
    const modalContent = {} as ModalContent;

    switch (step) {
      case 0:
        modalContent.title = 'Welcome to College Search';
        modalContent.text = (
          <>
            <p>
              Here&apos;s where you can learn about thousands of colleges and find the perfect fit
              for you.
            </p>
            <p className="bold">
              Follow the colleges you&apos;re interested in learning more about or those you&apos;d
              like to apply to.
            </p>
          </>
        );
        modalContent.ModalImage = Image1;
        break;
      case 1:
        modalContent.title = 'Why is Following so important?';
        modalContent.ModalImage = Image2;
        modalContent.text = (
          <>
            <p>
              If the college you follow is a Raise Me partner, you&apos;ll start earning
              micro-scholarships from them right away. If they aren&apos;t a partner yet, Following
              guarantees that you&apos;ll be notified as soon as they start offering
              micro-scholarships on Raise Me.
            </p>
          </>
        );
        break;
    }
    return modalContent;
  };

  const {ModalImage, title, text} = getModalContent();

  const secondaryButton = step === 1 ? {onClick: onBackClick, width: 120, text: 'Back'} : undefined;

  return (
    <Modal show className="welcome-modal">
      <Modal.ImageHeader
        onClose={handleClose}
        backgroundImage={ModalImage}
        backgroundColor="b300"
        color="white"
      >
        {title}
      </Modal.ImageHeader>
      <Modal.Body>
        <div className="welcome-modal-text">{text}</div>
      </Modal.Body>

      <Modal.NavigationFooter
        stepCount={2}
        currentStep={step}
        primaryButton={{
          onClick: onNextClick,
          width: 120,
          text: step === 1 ? 'Got It' : 'Next',
        }}
        secondaryButton={secondaryButton}
      />
    </Modal>
  );
};

export default WelcomeModal;
